import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/rawMaterials/QueryPage'
export const batchUpdateOrDelete = '/icps/system/sign/basics/rawMaterials/deletes'
export const updateSortNum = ''
export const Download = '/icps/system/sign/basics/rawMaterials/exportList'
export const saveOrUpdate = '/icps/system/sign/basics/rawMaterials/saveOrUpdate'
/*获取基础配置的原物料列表*/
export function queryMaterialsPage() {
  return request({
    url: '/icps/system/sign/basics/rawMaterials/QueryList',
    method: 'post'
  })
}

/*修改价格*/
export function queryPageMoney(data) {
  return request({
    url: '/icps/system/sign/basics/rawmaterialsMoney/queryPage',
    method: 'post',
    data
  })
}
export function saveOrUpdateMoney(data) {
  return request({
    url: '/icps/system/sign/basics/rawmaterialsMoney/saveOrUpdate',
    method: 'post',
    data
  })
}
export function deletesMoney(data) {
  return request({
    url: '/icps/system/sign/basics/rawmaterialsMoney/deletes',
    method: 'post',
    data
  })
}
export function qureyCodeIs(data) {
  return request({
    url: '/icps/system/sign/basics/rawMaterials/qureyCodeIs',
    method: 'post',
    data
  })
}